import Login from '@screens/login/login'

import Home from '@screens/home/home'
import BusinessFocus from '../screens/focus/businessFocus'
import OrphanFocus from '../screens/focus/orphanFocus'
import BusinessDetails from '../screens/details/businessDetails'
import DeclarationDetails from '../screens/details/declarationDetails'
import PicturesDetails from '../screens/details/picturesDetails'

import AdminExternals from '@app/ui/screens/admin/externalUsers'
import AdminInternals from '@app/ui/screens/admin/internalUsers'
import AdminBusinesses from '@screens/admin/businesses'
import AdminCompanies from '@screens/admin/companies'
import AdminCompanyGroup from '@screens/admin/companyGroup'
import AdminData from '@app/ui/screens/admin/data'

import MonitorByRegion from '@screens/monitor/MonitorByRegion'
import Information from '@screens/home/information'

const screens: ScreenDefinition[] = [
  // Pages d'authentification
  {
    name: 'login',
    screen: Login,
    position: 'none',
    path: '/',
    header: false,
    authenticated: false,
    props: { auto: false },
  },
  {
    name: 'login',
    screen: Login,
    position: 'none',
    path: '/auto',
    header: false,
    authenticated: false,
    props: { auto: true },
  },
  {
    name: 'loginOkta',
    screen: Login,
    position: 'none',
    path: '/login/okta/callback',
    header: false,
    authenticated: false,
  },
  {
    name: 'loginSofit',
    screen: Login,
    position: 'none',
    path: '/login/sofit/callback',
    header: false,
    authenticated: false,
  },
  {
    name: 'logout',
    screen: Login,
    position: 'none',
    path: '/logout',
    header: false,
    authenticated: true,
  },
  // Pages de fonctionnalités
  {
    name: 'home',
    screen: Home,
    position: 'none',
    path: '/',
    header: false,
    authenticated: true,
  },
  {
    name: 'businessFocus',
    screen: BusinessFocus,
    position: 'none',
    path: '/focus/business/:businessId',
    header: false,
    authenticated: true,
  },
  {
    name: 'orphanFocus',
    screen: OrphanFocus,
    position: 'none',
    path: '/focus/orphan/:orphanId',
    header: false,
    authenticated: true,
  },
  {
    name: 'businessDetails',
    screen: BusinessDetails,
    position: 'none',
    path: '/business/:businessId',
    header: false,
    authenticated: true,
  },
  {
    name: 'picturesDetails',
    screen: PicturesDetails,
    position: 'none',
    path: '/business/pictures/:businessId',
    header: false,
    authenticated: true,
  },
  {
    name: 'declarationDetails',
    screen: DeclarationDetails,
    position: 'none',
    path: '/business/:businessId/declaration/:declarationId',
    header: false,
    authenticated: true,
  },
  // Pages d'administration
  {
    name: 'adminInternalUsers',
    screen: AdminInternals,
    position: 'none',
    path: '/admin/internals',
    header: false,
    authenticated: true,
  },
  {
    name: 'adminExternalUsers',
    screen: AdminExternals,
    position: 'none',
    path: '/admin/externals',
    header: false,
    authenticated: true,
  },
  {
    name: 'adminCompanies',
    screen: AdminCompanies,
    position: 'none',
    path: '/admin/companies',
    header: false,
    authenticated: true,
  },
  {
    name: 'adminCompaniesGroup',
    screen: AdminCompanyGroup,
    position: 'none',
    path: '/admin/companies/group',
    header: false,
    authenticated: true,
  },
  {
    name: 'adminBusinesses',
    screen: AdminBusinesses,
    position: 'none',
    path: '/admin/businesses',
    header: false,
    authenticated: true,
  },
  {
    name: 'adminData',
    screen: AdminData,
    position: 'none',
    path: '/admin/data',
    header: false,
    authenticated: true,
  },
  {
    name: 'monitorRegion',
    screen: MonitorByRegion,
    position: 'none',
    path: '/monitor/region',
    header: false,
    authenticated: true,
  },
  {
    name: 'information',
    screen: Information,
    position: 'none',
    path: '/information',
    header: false,
    authenticated: true,
  },
]

export default screens
